import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addHomeGroupStaffFailure,
  //
  addHomeGroupStaffSuccess,
  deleteHomeGroupStaffFailure,
  //
  deleteHomeGroupStaffSuccess,
  editHomeGroupStaffFailure,
  //
  editHomeGroupStaffSuccess,
  fetchHomeGroupStaffs as fetchHomeGroupStaffsAction,
  fetchHomeGroupStaffsFailure,
  fetchHomeGroupStaffsSuccess,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_HOME_GROUP_STAFF,
  DELETE_HOME_GROUP_STAFF,
  EDIT_HOME_GROUP_STAFF,
  FETCH_HOME_GROUP_STAFFS,
  GET_VIEW_DATA,
} from "./constants";
import { inviteStaff } from "../SlickCareProfiles/actions";

export function* fetchHomeGroupStaffsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/company-admin-user?${query}`
    );
    yield put(fetchHomeGroupStaffsSuccess(data));
  } catch (e) {
    yield put(fetchHomeGroupStaffsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching staff!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/company-admin-user/${payload}`
    );
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addHomeSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const userInfo = yield select((state) => state?.AuthReducer?.user);
  const activeLocation = yield select(
    (state) => state?.SlickCareProfilesReducer?.activeLocation
  );

  try {
    const data = yield call(
      api(token).post,
      `/api/company-admin-user/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Staff added successfully!"));
      yield put(addHomeGroupStaffSuccess());
      yield put(
        fetchHomeGroupStaffsAction({
          page: 1,
          limit: 10,
          user_id: userInfo?.id,
          location_id: activeLocation?.id,
        })
      );
    }
  } catch (e) {
    yield put(addHomeGroupStaffFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editHomeSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const userInfo = yield select((state) => state?.AuthReducer?.user);
  const activeLocation = yield select(
    (state) => state?.SlickCareProfilesReducer?.activeLocation
  );
  try {
    const data = yield call(
      api(token).post,
      `/api/company-admin-user/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Staff updated successfully!"));
      yield put(editHomeGroupStaffSuccess());
      yield put(
        fetchHomeGroupStaffsAction({
          page: 1,
          limit: 10,
          user_id: userInfo?.id,
          location_id: activeLocation?.id,
        })
      );
    }
  } catch (e) {
    yield put(editHomeGroupStaffFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteStaffSaga({ payload, onDeleteSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const user = yield select((state) => state?.AuthReducer?.user);
  try {
    const data = yield call(
      api(token).delete,
      `/api/company-admin-user/${payload?.id}`
    );
    if (data) {
      yield put(successAlert("Staff deleted successfully!"));
      yield put(deleteHomeGroupStaffSuccess());
      typeof onDeleteSuccess === "function" && onDeleteSuccess();
    }
  } catch (e) {
    yield put(deleteHomeGroupStaffFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchHomeGroupStaffsFlow() {
  yield takeEvery(FETCH_HOME_GROUP_STAFFS, fetchHomeGroupStaffsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addHomeFlow() {
  yield takeEvery(ADD_HOME_GROUP_STAFF, addHomeSaga);
}
export function* editHomeFlow() {
  yield takeEvery(EDIT_HOME_GROUP_STAFF, editHomeSaga);
}
export function* deleteHomeFlow() {
  yield takeEvery(DELETE_HOME_GROUP_STAFF, deleteStaffSaga);
}

export default function* HomeGroupsStaffSaga() {
  yield all([
    fetchHomeGroupStaffsFlow(),
    addHomeFlow(),
    editHomeFlow(),
    deleteHomeFlow(),
    getViewDataFlow(),
  ]);
}
